module.exports = __webpack_public_path__ + "static/media/step-5-en.27dfd562.jpg";